import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ExtMetaConfigModel } from '@smarttask-common/src/lib/models/Integrations/Meta/Config/ExtMetaConfigModel';

export enum MetaConfigActionTypes {
    ADD_META_CONFIG = '[MetaConfig] Create MetaConfig',
    ADD_META_CONFIGS = '[MetaConfig] Add MetaConfigs',
    UPSERT_META_CONFIG = '[MetaConfig] Upsert MetaConfig',
    UPSERT_META_CONFIGS = '[MetaConfig] Upsert MetaConfigs',
    UPDATE_META_CONFIG = '[MetaConfig] Update MetaConfig',
    UPDATE_META_CONFIGS = '[MetaConfig] Update MetaConfigs',
    DELETE_META_CONFIG = '[MetaConfig] Delete MetaConfig',
    DELETE_META_CONFIGS = '[MetaConfig] Delete MetaConfigs',
    DELETE_ALL_META_CONFIGS = '[MetaConfig] Delete All MetaConfigs',
    DELETE_ALL = '[MetaConfig] Delete All',

    UPDATE_SELECTED_ID = '[MetaConfig] Update SelectedId',
}

export class UpdateSelectedConfigId implements Action {
    readonly type = MetaConfigActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_config_id: number) {}
}

export class AddOne implements Action {
    readonly type = MetaConfigActionTypes.ADD_META_CONFIG;
    constructor(public config: ExtMetaConfigModel) {}
}

export class AddMany implements Action {
    readonly type = MetaConfigActionTypes.ADD_META_CONFIGS;
    constructor(public configs: Array<ExtMetaConfigModel>) {}
}

export class UpsertOne implements Action {
    readonly type = MetaConfigActionTypes.UPSERT_META_CONFIG;

    constructor(public config: ExtMetaConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = MetaConfigActionTypes.UPSERT_META_CONFIGS;
    constructor(public configs: Array<ExtMetaConfigModel>) {}
}

export class UpdateOne implements Action {
    readonly type = MetaConfigActionTypes.UPDATE_META_CONFIG;
    constructor(public config: Update<ExtMetaConfigModel>) {}
}

export class UpdateMany implements Action {
    readonly type = MetaConfigActionTypes.UPDATE_META_CONFIGS;
    constructor(public configs: Array<Update<ExtMetaConfigModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = MetaConfigActionTypes.DELETE_META_CONFIG;
    constructor(public config_id: number) {}
}

export class DeleteMany implements Action {
    readonly type = MetaConfigActionTypes.DELETE_META_CONFIGS;
    constructor(public config_ids: Array<number>) {}
}

export class DeleteAll implements Action {
    readonly type = MetaConfigActionTypes.DELETE_ALL_META_CONFIGS;
    constructor(public config_ids: Array<number>) {}
}

export class DeleteState implements Action {
    readonly type = MetaConfigActionTypes.DELETE_ALL;
    constructor() {}
}

export type MetaConfigActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedConfigId;
